import { gql } from "generated-graphql";

export const INBOUND_EMAIL_QUERY = gql(`
  query ManifestInboundEmail($search: String, $page: Int, $pageSize: Int, $sort: [SortModel!]) {
    receivedEmails(search: $search, page: $page, pageSize: $pageSize, sort: $sort) {
      items {
        id
        receivedAt
        fromAddress
        subject
        outcome
        rejectionReason
        attachmentsProcessedCount
        attachmentsTotalCount
        tenant {
          id
          name
        }
      }
      count
    }
  }
`);

export const CROSS_TENANT_SENDERS_QUERY = gql(`
  query CrossTenantEmailIntakeSenders(
    $search: String
    $page: Int
    $pageSize: Int
    $sort: [SortModel!]
  ) {
    emailIntakeSenders(search: $search, page: $page, pageSize: $pageSize, sort: $sort) {
      items {
        sender {
          id
          tenantId
          matchType
          value
          includeSubdomains
          enabled
          label
          facility {
            id
            name
            city
            state
          }
          lastReceivedAt
          documentCount
          createdAt
          createdBy
          updatedAt
          updatedBy
        }
        tenant {
          id
          name
        }
        intakeState
        conflicts {
          tenantId
          tenantName
          enabled
          kind
          value
        }
      }
      count
    }
  }
`);

export const INTAKE_ADDRESS_QUERY = gql(`
  query ManifestIntakeAddress {
    emailIntakeAddress
  }
`);
